export default __webpack_public_path__ + "static/media/HandheldBandSawImg.2d130b21.png";